import { useEffect, useRef, useState } from 'react';
import type { Nullable } from 'corgi-types';

import { useResize } from 'common/hooks/resize';
import type { PrimaryNavigationItemProps } from 'common/types/NavigationItem';

const OTHER_BUTTON_WIDTH = 70;

export const useWrapItems = (items: PrimaryNavigationItemProps[], wrapOthers: boolean) => {
  const containerRef = useRef<Nullable<HTMLDivElement>>(null);
  const itemsRef = useRef<Nullable<HTMLAnchorElement[]>>([]);
  const itemsWidth = useRef<number[]>([]);
  const [visibleItemsCount, setVisibleItemsCount] = useState(items.length);

  const handleResize = () => {
    const container = containerRef.current;
    if (!wrapOthers || !container || !itemsWidth.current) {
      return;
    }

    const containerWidth = container.offsetWidth;
    const { paddingLeft, paddingRight } = window.getComputedStyle(container);
    const containerPaddings = parseFloat(paddingLeft) + parseFloat(paddingRight);

    let totalItemsWidth = 0;
    let count = 0;

    for (const item of itemsWidth.current) {
      totalItemsWidth += item;
      if (totalItemsWidth > containerWidth - containerPaddings - OTHER_BUTTON_WIDTH) {
        break;
      }
      count++;
    }
    setVisibleItemsCount(count);
  };

  useEffect(() => {
    // Save all items width, to not lose it after unmounting remaining ones
    itemsWidth.current = itemsRef.current.map(item => {
      const width = item.offsetWidth;
      const { marginLeft, marginRight } = window.getComputedStyle(item);

      return width + parseFloat(marginLeft) + parseFloat(marginRight);
    });
    handleResize();
  }, []);

  useResize(handleResize);

  useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, items.length);
  }, [items]);

  return { visibleItemsCount, containerRef, itemsRef };
};
